export enum ProgressMeterState {
  VERY_HIGH,
  HIGH,
  MEDIUM,
  LOW,
  VERY_LOW,
}
